export enum ENVIRONMENT {
    DEVELOPMENT,
    DEVELOPMENT_ACCOUNT_KIT,
    REDSTONE,
    REDSTONE_TEST,
    GARNET,
    GARNET_ACCOUNT_KIT
}